import { defineEntity, object, string } from '~/prix'

const studentEad = defineEntity({
  key: 'aluno',
  title: 'EAD aluno',
  sources: ['oltp', 'olap'],
  entitySchema: 'ead',
  schema: object({
    id: string().label('ID'),
    cpf: string().label('CPF'),
    nome: string().label('Nome'),
    telefone: string().label('Telefone'),
    sexo: string().label('Sexo'),
    dataNascimento: string().label('Data de nascimento'),
    escolaridade: string().label('Escolaridade'),
    dataCriacao: string().label('Data de criação'),
    dataAtualizacao: string().label('Data de atualização'),
    uf: string().label('Unidade Federativa'),
  }),
})

export default studentEad
